import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import TicketCommande from "../../../app/views/Pdf/TicketCommande"
import TicketCommandeSupplement from "../../../app/views/Pdf/TicketCommandeSupplement"
import useLoadPublicDocument from './useLoadPublicDocument';
import PublicDocumentNotFound from './PublicDocumentNotFound';
import PublicPdfPreview from './PublicPdfPreview';
import {computePublicTicketTotals} from './publicTicketTotals';

/**
 * Page publique de consultation d'une commande B2C (sans authentification), affiche son PDF.
 * Une commande annulée reste consultable, avec un bandeau d'avertissement.
 */
const PublicVisualCommande = ({company,id,token}) => {
    const t = useTranslate();
    const [loading,response,error404] = useLoadPublicDocument('commande_public', company, id, token)
    const commandeDetail = response.data || {}
    const section = response.section || {}
    const companyInfos = response.company || {}
    const moduleInfos = response.module || {}

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    if(error404 || Object.keys(commandeDetail).length==0){
        return(<PublicDocumentNotFound />)
    }

    const {digit,totalAchat,tgcForTicketPdf,tgcTotal} = computePublicTicketTotals(commandeDetail.ticket.ticket_detail, companyInfos)

    const supplement_list_params = moduleInfos.params?.article?.params?.supplement_list
    const TicketCommandeComponent = supplement_list_params ? TicketCommandeSupplement : TicketCommande

    return(<>
        {commandeDetail.cancel &&
            <div className="alert alert-danger m-3">{t('saleOrderCanceled')}</div>
        }
        <PublicPdfPreview
            title="Aperçu de la commande"
            document={
                <TicketCommandeComponent
                    thisShop={section}
                    ticketPdf={commandeDetail}
                    t={t}
                    devise={companyInfos.devise}
                    digit={digit}
                    totalAchat={totalAchat}
                    tgcTotal={tgcTotal}
                    tgcForTicketPdf={tgcForTicketPdf}
                    moduleParam={moduleInfos}
                    authParam={{company:companyInfos}}
                />
            }
        />
    </>)
}

export default PublicVisualCommande;
